import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack, Typography } from "@mui/material";
import Icon from "@shared/components/Icon";
import ImageContainer from "@shared/components/contents/imageContainer/ImageContainer";
const WitnessCard = (props) => {
    const { witness, iconColor, image, title, description } = props;
    return (_jsxs(Stack, { sx: {
            p: { xs: 3, md: 4 },
            outline: "1px solid",
            outlineColor: "text.secondary",
            minHeight: { md: "auto", lg: "437px" },
            height: { sm: "fit-content", md: "-webkit-fill-available" },
            "@supports (height: stretch)": {
                height: { md: "stretch" },
            },
            justifyContent: "space-between",
            backgroundColor: "primary.contrastText",
        }, children: [_jsxs(Stack, { spacing: 2.5, children: [_jsx(Icon, { type: "custom", icon: "citation_2", color: iconColor, style: { minWidth: "32px", minHeight: "32px" } }), _jsx(Typography, { variant: "body1", children: witness })] }), _jsxs(Box, { children: [_jsx(Divider, { sx: { mt: { xs: 2, md: 3 }, bgcolor: "text.secondary" } }), _jsxs(Stack, { direction: "row", spacing: { xs: 1.5, md: 2.5 }, sx: { mt: { xs: 2, md: 3 }, alignItems: "center" }, children: [image && (_jsx(Box, { sx: {
                                    width: { xs: 48, md: 60 },
                                    height: { xs: 48, md: 60 },
                                    flexShrink: 0,
                                }, children: _jsx(ImageContainer, { ratio: "", children: image }) })), _jsxs(Stack, { spacing: { xs: 0.25, md: 0.5 }, children: [title && (_jsx(Typography, { variant: "subtitle1", component: "p", children: title })), description && (_jsx(Typography, { variant: "body2", sx: {
                                            color: "text.secondary",
                                        }, children: description }))] })] })] })] }));
};
export default WitnessCard;
